module.exports = __webpack_public_path__ + "static/media/tyre-yellow-two2.c1b2ca24.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tyre-yellow-two2.png
// module id = 354
// module chunks = 0